<template>
    <div class="table">
        <div class="container">
            <div class="row table_header">
            <div class="col-4 fz">🙋 ФИО</div>
            <div class="col-4 text-align fz">📈 Этап</div> 
            <div class="col-4 text-align fz">👥 Продукт</div></div>
        </div>
        <div class="container">
            <div v-for="user in users_list" :key="user.user_id" @click="
            this.$store.commit('setUserId', user.user_id);
            this.$router.push(`/user/${user.user_id}`);"
            class="user_card row">
            <div class="col-4">{{ user.user_fio }}</div>
            <div class="col-4 text-align">{{ this.stages[user.user_stage] }}</div> 
            <div class="col-4 text-align">{{ this.products[user.product_choice] }}</div></div>
        </div>
    </div>
</template>

<script>
import { RouterLink } from 'vue-router';
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';


    export default {
        data(){
            return{
                stages: {'greetings': "Приветствие", 'pick_product': "Выбор продукта", 'form': "Заполнение анкеты",
          'check_credit_history': "Кредитная история", 'upload_docs': "Загрузка документов",
          'prepare_contract': 'Ожидает договор', 'contract_ready': 'Договор отправлен',
          'payment': 'Ожидает ссылку на оплату', 'payment_ready': 'Ссылка на оплату отправлена',
          'payment_done': "Клиент оплатил", 'payment_approved': 'Оплата подтверждена - Одобрение ипотеки',
          'mortgage_approving_result': 'Решение по ипотеке', 'buy_estate_form': 'Покупка недвижимости - Анкета',
          'buy_estate_upload_docs': 'Покупка недвижимости - Документы', 'buy_estate_contract': 'Покупка недвижимости - Договор',
          'buy_estate_payment': 'Покупка недвижимости - Оплата', 'buy_estate_selection': 'Покупка недвижимости - Подбор',
          'buy_estate_buying': 'Покупка недвижимости - Покупка', 'sell_estate_form': 'Продажа недвижимости - Анкета', 'finish': 'Финал'},
            products: {"mortgage_btn": "Ипотека под ключ", "mortgage_new_flat_btn": "Покупка новостройки под ключ", "None": "Пока не выбран" }

            }
        },
    name: "c_table",
    props: {
        users_list: {
            type: Array,
            required: true
        }
    },
    components: { RouterLink },
    methods: {
        ...mapMutations({
            setUserId: 'setUserId',
        })},
        cardClicked(event){
            
        }
}
</script>

<style scoped>

.table{
    display: block;
}
.table_header {
    font-size: 20px;
    margin: 5px;
    padding: 10px 5px;
    border-radius: 5px;
    transition: .4s;
}
.user_card{
    font-size: 18px;
    border: 1px solid rgb(31, 49, 79);
    margin: 5px;
    padding: 10px 5px;
    border-radius: 5px;
    transition: .4s;
}
.user_card:active {
    transform: scale(1.1);
    border: 2px double rgb(15, 30, 56);
}
.text-align{
    text-align: center;
}
.fz {
    font-size: 16px;
}

</style>